import { useContext, useEffect } from "react";
import PoolRankingGrid from "../components/PoolRankingGrid/PoolRankingGrid";
import i18n from "../../../i18n";
import { RootContext } from "../../../providers/RootProvider";
import PageContainer from "../../../uikit/PageContainer/PageContainer";
import { useAptabase } from "@aptabase/react";
import { useFetchRanking } from "../../../api/hooks";

const RankingPage = () => {
  const { selectedPhaseId } = useContext(RootContext);
  const { data: ranking } = useFetchRanking(selectedPhaseId);
  const { trackEvent } = useAptabase();

  useEffect(() => {
    trackEvent("page_view", { screenName: "ranking_page" });
  }, [trackEvent]);

  return (
    <PageContainer title={i18n.t("navigation:ranking:title")}>
      <PoolRankingGrid pools={ranking} />
    </PageContainer>
  );
};

export default RankingPage;
